const equipmentsByPlace = {
  word1:'mostrando',
  word2:'de',
  word3:'equipamento'
}

export default equipmentsByPlace;
